/**
 * Created by Marek.Bogdanovic on 2017-10-12.
 */
/**
 * Validation method that test if the field is valid against a regular expression, on special condition.
 */
/** EXAMPLE
 <input id='phone'
 name='phone'
 data-regular_condition='^\d{8}$' // Regular expression validation when condition is fulfilled.
 data-regular_condition_field='#phone_code' // Search field for compare condition expression.
 data-regular_condition_value='^(\+47|47|047)$' // Regular expression values to compare in field.
 data-rule-regular_condition='true'
 data-error-regular_condition='phone2-error'>
 */
export var regularCondition = function (value, element) {
    var conditionField = element.dataset.regular_condition_field
        ? document.querySelector(element.dataset.regular_condition_field)
        : null;
    var conditionExpression = element.dataset.regular_condition_value
        ? element.dataset.regular_condition_value
        : '';
    if (!conditionField || !conditionExpression) {
        return true;
    }
    var conditionFieldValue = conditionField.value
        ? conditionField.value
        : null;
    var regularConditionExpression = new RegExp(conditionExpression);
    if (!regularConditionExpression.test(conditionFieldValue)) {
        return true;
    }
    var expression = element.dataset.regular_condition
        ? element.dataset.regular_condition
        : '';
    var regularExpression = new RegExp(expression);
    return regularExpression.test(value);
};
